export var errorToString=function(r){return null==r?"":r instanceof Error?"".concat(r.name,": ").concat(r.message):String(r)};